export default {
  meta: {
    title: '话术即查',
    url: '/abside/verbaltrick', // 埋点字段，上报归属的模块
    urlName: 'ab侧-话说', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
